import { Transition, Variants } from 'motion/react';

/**
 * Standard macOS-style spring physics.
 * Damping around 25-28 and stiffness around 250-300 provides that
 * snappy yet smooth "Apple" feel.
 */
export const macSpring: Transition = {
  type: 'spring',
  damping: 26,
  stiffness: 280,
  mass: 1,
};

/**
 * Faster spring for micro-interactions or closing.
 */
export const macSpringFast: Transition = {
  type: 'spring',
  damping: 32,
  stiffness: 400,
  mass: 1,
};

/**
 * macOS Window / Modal animation variants.
 * Scales up from 0.85 and fades in.
 */
export const macWindowVariants: Variants = {
  initial: { 
    opacity: 0, 
    scale: 0.85, 
    y: 15,
    filter: 'blur(10px)'
  },
  animate: { 
    opacity: 1, 
    scale: 1, 
    y: 0,
    filter: 'blur(0px)',
    transition: macSpring
  },
  exit: { 
    opacity: 0, 
    scale: 0.9, 
    y: 10,
    filter: 'blur(5px)',
    transition: { duration: 0.15, ease: 'easeOut' }
  }
};

/**
 * macOS Panel / Sidebar animation variants (Slide from side).
 */
export const macPanelVariants = (side: 'left' | 'right' | 'top' | 'bottom' = 'left'): Variants => ({
  initial: { 
    x: side === 'left' ? '-100%' : side === 'right' ? '100%' : 0,
    y: side === 'top' ? '-100%' : side === 'bottom' ? '100%' : 0,
    opacity: 0.8
  },
  animate: { 
    x: 0, 
    y: 0,
    opacity: 1,
    transition: macSpring
  },
  exit: { 
    x: side === 'left' ? '-100%' : side === 'right' ? '100%' : 0,
    y: side === 'top' ? '-100%' : side === 'bottom' ? '100%' : 0,
    opacity: 0.8,
    transition: { ...macSpringFast, mass: 0.8 }
  }
});

/**
 * Pop-up / Tooltip style animation (Scale up from center or bottom).
 */
export const macPopUpVariants: Variants = {
  initial: { 
    opacity: 0, 
    scale: 0.6, 
    y: 10 
  },
  animate: { 
    opacity: 1, 
    scale: 1, 
    y: 0,
    transition: macSpring
  },
  exit: { 
    opacity: 0, 
    scale: 0.6, 
    y: 10,
    transition: { duration: 0.1 }
  }
};

/**
 * Standard hover effect for Mac-like buttons.
 */
export const macButtonHover = {
  scale: 1.03,
  y: -1,
  transition: { type: 'spring', stiffness: 400, damping: 10 }
};

export const macButtonTap = {
  scale: 0.97,
  y: 0
};
